import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const AirportPaginatedDropdown = (props: DropdownWithoutOptionsProps<server.dto.AirportSmall>) => {
  const fetchAirports = async (search: string, page: number) => {
    const res = await window.CoreApi.Airport.PaginatedSmall({
      excludeKeys: props.excludeKeys ?? [],
      keyword: search,
      airportSize: "allAirports",
      page,
      perPage: 10
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchAirports}
    getLabel={a => a.name}
    getValue={a => a.airportId}
    getSubLabel={a => a.location}
    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default AirportPaginatedDropdown;